import { defineMessages } from "react-intl";

export const operatorMessages = defineMessages({
  platformName: {
    defaultMessage: "Operations",
    id: "TFUQ+l",
    description: "operator platform name, shown in its top bar and window title",
  },
  labelsModule: {
    defaultMessage: "Labels",
    id: "Pn3D0i",
    description: "operator platform module: printing product labels",
  },
  logout: {
    defaultMessage: "Log out",
    id: "/qzhbd",
    description: "operator platform, log out button",
  },
  toggleTheme: {
    defaultMessage: "Toggle dark mode",
    id: "1IjM9w",
    description: "operator platform, theme toggle button label",
  },
  noAccessTitle: {
    defaultMessage: "No access",
    id: "sjj2ts",
    description: "operator platform, title when the user has no operator role",
  },
  noAccessBody: {
    defaultMessage:
      "Your account has no role on the operations platform. Ask an administrator to add you to the right group (e.g. “Label Operator”).",
    id: "YdeDce",
    description: "operator platform, explanation when the user has no operator role",
  },
});
